import React, { useState } from 'react';
import { Chat } from './Chat';
import { ChatInput } from './ChatInput';
import { useAuth } from '../../hooks/useAuth';

interface Message {
  role: 'user' | 'assistant';
  content: string;
}

export const FragmentsInterface = () => {
  const { user } = useAuth();
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!input.trim() || isLoading) return;

    const newMessage: Message = {
      role: 'user',
      content: input,
    };

    setMessages(prev => [...prev, newMessage]);
    setInput('');
    setIsLoading(true);

    try {
      // TODO: Implementar chamada à API
      const response = await fetch('/api/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          messages: [...messages, newMessage],
          model: 'gpt-4',
        }),
      });

      const data = await response.json();
      
      setMessages(prev => [...prev, {
        role: 'assistant',
        content: data.message,
      }]);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-full bg-[#0A0A0A] text-white">
      {/* Header */}
      <header className="flex items-center justify-between p-4 border-b border-white/[0.08]">
        <div className="flex items-center space-x-2">
          <img src="/images/fragments-logo.svg" alt="Fragments" className="h-6" />
          <span className="text-white">Fragments by</span>
          <a href="https://e2b.dev" className="text-[#FF6B2C] hover:underline">E2B</a>
        </div>
      </header>

      {/* Chat Area */}
      <Chat messages={messages} isLoading={isLoading} />

      {/* Input Area */}
      <ChatInput
        input={input}
        setInput={setInput}
        onSubmit={handleSubmit}
        isLoading={isLoading}
      />
    </div>
  );
};
